import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export interface PublicNewsArticle {
  id: string;
  title: string;
  content: string;
  excerpt: string | null;
  published_at: string | null;
  created_at: string;
  attachments: { url: string; name: string }[];
}

export function usePublishedNews() {
  return useQuery({
    queryKey: ['published-news'],
    queryFn: async () => {
      const { data, error } = await (supabase as any)
        .from('news')
        .select('id, title, content, excerpt, published_at, created_at, sort_order, attachments')
        .eq('is_published', true)
        .order('sort_order', { ascending: true });
      if (error) throw error;
      return data as PublicNewsArticle[];
    },
  });
}

export function usePublishedNewsArticle(id: string | undefined) {
  return useQuery({
    queryKey: ['published-news', id],
    enabled: !!id,
    queryFn: async () => {
      const { data, error } = await (supabase as any)
        .from('news')
        .select('id, title, content, excerpt, published_at, created_at, attachments')
        .eq('id', id)
        .eq('is_published', true)
        .single();
      if (error) throw error;
      return data as PublicNewsArticle;
    },
  });
}
